import { approvalStatus } from '../data/approval.js';

/**
 * The "Approval" field (Add System Phase 7, vault spec "The two settings, and the Approval field") —
 * one name at every layer, like Is Collection (utils/collectionField.js) and Price
 * (utils/priceBandField.js):
 *
 *   view configs persist  'approval'                (a filter's `columnId`, a Grid column id)
 *   display name          "Approval"
 *   read it with          approvalWord(node)        → 'Pending' | 'Approved' | 'Rejected' | null
 *   guard a field ref     isApprovalField(ref)
 *
 * The value is `items.approval_status`, carried on the node as `node.approval` (itemFieldMapping).
 * READ-ONLY everywhere: the column changes only through approve_item / reject_item, which the
 * Approval column's buttons and the Info banner call. So the filter is all the queue is: "Approval is
 * Pending". Only a pending or rejected item's creator and the space's admins ever see one, so the
 * field says nothing to anyone else.
 */
export const APPROVAL_FIELD_KEY = 'approval';
export const APPROVAL_FIELD_LABEL = 'Approval';

export const APPROVAL_WORDS = Object.freeze({ pending: 'Pending', approved: 'Approved', rejected: 'Rejected' });

export const APPROVAL_FIELD_DEF = Object.freeze({
  id: APPROVAL_FIELD_KEY,
  name: APPROVAL_FIELD_KEY,
  label: APPROVAL_FIELD_LABEL,
  type: 'singleSelect',
  source: 'internal',
  synthetic: true,
  readOnly: true,
  options: { choices: Object.values(APPROVAL_WORDS).map((name) => ({ name })) },
});

/** Column-shaped, for the Grid/List inline filter row (see IS_COLLECTION_FILTER_COLUMN). */
export const APPROVAL_FILTER_COLUMN = Object.freeze({
  id: APPROVAL_FIELD_KEY,
  label: APPROVAL_FIELD_LABEL,
  type: 'singleSelect',
  readOnly: true,
  options: APPROVAL_FIELD_DEF.options,
  accessor: (row) => approvalWord(row),
});

/** Key only, so a space's own jsonb field called "Approval" is never hijacked. */
export function isApprovalField(fieldRef) {
  return fieldRef === APPROVAL_FIELD_KEY;
}

/** The node's approval as its word, or null when it was never gated. */
export function approvalWord(node) {
  const s = approvalStatus(node);
  return s ? APPROVAL_WORDS[s] : null;
}
